import { createAsyncThunk } from '@reduxjs/toolkit';

export const createChangeTierAction = slice_name =>
  createAsyncThunk(
    `${slice_name}/changeTier`,
    ({ tier }) => (window.location.href = tier.get('upgradeUrlMonthly'))
  );
